export enum CycleType {
    ITEM = 0,
    USER = 1
}